<template>
  <div class="flex flex-wrap border border-black m1 col-12 sm-col-12 md-col-8 lg-col-10 pointer" @click="selectSession()">
    <div
      class="flex justify-center items-center col-2 sm-col-2 md-col-2 lg-col-1"
      :class="[{
        'light-blue-bg white': isSelected
      }]"
    >
      <i class="flex icon icon-clock h1"></i>
    </div>
    <div class="flex flex-wrap col-10 sm-col-10 md-col-10 lg-col-11 p2">
      <div class="flex col-12">De {{ formatSession(session.startTime, "PPPP") }} au {{ formatSession(session.lastTime, "PPPP") }}</div>
      <div class="flex col-12">{{ formatSession(session.startTime, "HH'h'mm") }} - {{ formatSession(session.endTime, "HH'h'mm") }}</div>
    </div>
  </div>
</template>

<script>
import { frenchTime } from '@/utils/utils';

export default {
  props: {
    session: {
      type: Object,
      required: true
    }
  },
  computed: {
    siteInfo () {
      return this.$store.state.siteInfo;
    },
    cartItem () {
      return this.$store.state.cartItem;
    },
    isSelected () {
      if (this.cartItem.session && this.cartItem.session.code === this.session.code) {
        return true;
      }
      return false;
    }
  },
  methods: {
    formatSession (time, dateFormat) {
      return frenchTime(time, dateFormat, this.siteInfo.timezone);
    },
    selectSession () {
      this.$store.commit('setCartItem', {
        ...this.cartItem,
        session: {
          ...this.session,
          startTime: this.formatSession(this.session.startTime, 'T'),
          endTime: this.formatSession(this.session.endTime, 'T'),
          lastTime: this.formatSession(this.session.lastTime, 'T')
        }
      });
    }
  }
};
</script>
